import mixpanel from "mixpanel-browser";

export const isProductionEnv = process.env.REACT_APP_NODE_ENV === "production";

export class MixPanel {
  static boot(mixpanelToken: string) {
    if (!mixpanelToken) return null;
    mixpanel.init(mixpanelToken);
    return mixpanel;
  }

  static isTrackable(): boolean {
    return isProductionEnv;
  }
}
